import { TrackedInput } from '@objectiv/tracker-react';
import { forwardRef } from 'react';

import { BaseInput } from '../BaseInput';

import type { BaseInputProps } from '../BaseInput';

export type InputProps = Omit<BaseInputProps<'input'>, 'children'>;

// https://www.figma.com/file/ssGmau7DMZsdIX7F6k0lGk/%E2%9A%A1%EF%B8%8F-Design-System?type=design&node-id=32-39&mode=design&t=ofKIuOSPHQWXBcWo-0
export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return <BaseInput ref={ref} Component={TrackedInput} {...props} />;
});
